"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheV2 = void 0;
const cache_1 = require("./cache");
class CacheV2 {
    constructor(store) {
        this.store = store;
        this.cache = new cache_1.Cache(this.store);
    }
    cleanCache() {
        // It could have some problems because the storage could be shared with other modules
        // or Could be generic like Cookies or LocalStorage
        this.store.clear();
    }
    removeCached(key) {
        this.store.removeItem(key);
        this.store.removeItem(key + '_TTL');
    }
    setCached(key, result, cacheLiveTime) {
        return this.cache.setCached(key, result, cacheLiveTime);
    }
    getCached(key) {
        return this.cache.getCached(key);
    }
}
exports.CacheV2 = CacheV2;
//# sourceMappingURL=cacheV2.js.map